import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AddBusiness from "./pages/AddBusiness";
import AdminLayout from "./pages/Admin/AdminLayout";
import AdminLogin from "./pages/Admin/AdminLogin";
import BusinessOwnerLogin from "./pages/BusinessOwner/BusinessOwnerLogin";
import EditBusiness from "./pages/BusinessOwner/EditBusiness";
import HelpPage from "./pages/HelpPage";

import "./App.css";
import "./styles/businessOwner.css";

// Lazy-loaded SEO routes — code-split, zero impact on homepage bundle
const BusinessPage  = lazy(() => import("./pages/BusinessPage"));
const CityPage      = lazy(() => import("./pages/CityPage"));
const CategoryPage  = lazy(() => import("./pages/CategoryPage"));

const SEOFallback = (
  <div className="loading-message">
    <span className="loading-spinner" />
  </div>
);

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <div className="app-container">
          <div className="wireframe-layout">

            <Header />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/add-business" element={<AddBusiness />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin"       element={<AdminLayout />} />

              {/* Business Owner */}
              <Route path="/business-owner/login" element={<BusinessOwnerLogin />} />
              <Route path="/business-owner/edit"  element={<EditBusiness />} />

              {/* Help */}
              <Route path="/help" element={<HelpPage />} />

              {/* SEO routes — lazy loaded */}
              <Route path="/business/:slug"     element={<Suspense fallback={SEOFallback}><BusinessPage /></Suspense>} />
              <Route path="/city/:city"         element={<Suspense fallback={SEOFallback}><CityPage /></Suspense>} />
              <Route path="/category/:category" element={<Suspense fallback={SEOFallback}><CategoryPage /></Suspense>} />
            </Routes>

            <ToastContainer position="top-center" />
            <Footer />

          </div>
        </div>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
